import React from 'react';
import MessageBubble from './MessageBubble';

function messageDay(timestamp) {
  if (!timestamp) return null;
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return null;
  return {
    key: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`,
    label: new Intl.DateTimeFormat(undefined, {
      weekday: 'short', month: 'short', day: 'numeric', year: 'numeric',
    }).format(date),
  };
}

export default function TranscriptPanel({
  messages,
  messagesEndRef,
  transcriptRef,
  onTranscriptScroll,
  playingMessageId,
  onPlayMessage,
  onStopMessage,
  onEditMessage,
  isResponding = false,
}) {
  return (
    <div
      ref={transcriptRef}
      onScroll={onTranscriptScroll}
      data-testid="conversation-transcript"
      className="br-transcript min-h-0 flex-1 overflow-y-auto overscroll-contain rounded-2xl border border-white/10 bg-white/5 px-2 py-4 shadow-inner scroll-smooth"
    >
      {messages.length === 0 && (
        <p className="br-transcript-empty text-center text-white/60 text-sm">
          No thoughts shared yet. I’m here when you’re ready.
        </p>
      )}

      <div className="space-y-3">
        {messages.map((msg, index) => {
          const day = messageDay(msg.created_at || msg.createdAt);
          const previous = index > 0 ? messageDay(messages[index - 1]?.created_at || messages[index - 1]?.createdAt) : null;
          const showDay = day && day.key !== previous?.key;
          return (
            <React.Fragment key={msg.id}>
              {showDay && (
                <div className="br-conversation-date" role="separator" aria-label={day.label}>
                  <span aria-hidden="true" />
                  <time dateTime={day.key}>{day.label}</time>
                  <span aria-hidden="true" />
                </div>
              )}
              <MessageBubble
                msg={msg}
                isPlaying={msg.id === playingMessageId}
                onPlay={onPlayMessage}
                onStop={onStopMessage}
                onEdit={onEditMessage}
              />
            </React.Fragment>
          );
        })}
        {isResponding && (
          <div
            className="br-response-pending"
            role="status"
            aria-live="polite"
            aria-label="BrightResolve is preparing a response"
            data-testid="response-thinking-indicator"
          >
            <span className="br-response-pending__light" aria-hidden="true"><i /><i /><i /></span>
          </div>
        )}
      </div>

      <div ref={messagesEndRef} />
    </div>
  );
}
